import { render, staticRenderFns } from "./prompt-inject.vue?vue&type=template&id=3586e6f4&scoped=true"
import script from "./prompt-inject.vue?vue&type=script&lang=js"
export * from "./prompt-inject.vue?vue&type=script&lang=js"
import style0 from "./prompt-inject.styl?vue&type=style&index=0&id=3586e6f4&prod&scoped=true&lang=stylus&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3586e6f4",
  null
  
)

export default component.exports